import React, {Component} from 'react';
import Table from '../../../../../components/Table';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
//import { personFullName } from '../../../../../services/Api';
import moment from 'moment';
import AnnuityPaymentFormModal from '../../../components/AnnuityPaymentFormModal';
import DeleteAnnuityPaymentModal from '../../../components/DeleteAnnuityPaymentModal';
import AnnuityPaymentDetailModal from '../../../components/AnnuityPaymentDetailModal';
import _ from "lodash";


class MembershipAnnuityPayments extends Component {

    static contextTypes = {api: PropTypes.object};

    constructor(props) {
        super(props);
        this.state = {};
        this.loadData = _.debounce(this.loadData, 450);

    }

    loadData = (tableState) => {
        this.tableState = tableState;
        const filters = {
            ...tableState.filters,
            'order[membership.id]': 'ASC',
            'order[paymentDate]': 'DESC',
            'type': 'membership'
        };
        this.context.api.annuityPayments.get(tableState.page, tableState.pageSize, '@Class.AnnuityPayments.annuityPayments.get', filters)
    };

    openAddPayment = () => this.setState({addingPayment: true});

    closeAddPayment = () => this.setState({addingPayment: false});

    onEditPayment = (e) => {
        e.stopPropagation();
        this.setState({editingPayment: e.currentTarget.dataset.index})
    };

    closeEditPayment = () => this.setState({editingPayment: false});

    onDeletePayment = (e) => {
        e.stopPropagation();
        this.setState({deletingPayment: e.currentTarget.dataset.index})
    };

    closeDeletePayment = () => this.setState({deletingPayment: false});

    deletePayment = (annuityPayment) => {
        this.context.api.annuityPayments.delete(annuityPayment.id);
        this.closeDeletePayment();
    };

    onDetailPayment = (e) => {
        this.setState({detailingPayment: e.currentTarget.dataset.index})
    };

    closeDetailPayment = () => this.setState({detailingPayment: false});

    getTrProps = (row, index) => ({'data-index': index, onClick: this.onDetailPayment});

    tableDefinition = () => {
        let tableDefinition = [
            {
                name: 'No. Miembro',
                id: 'membership.id',
                filterable: true,
                accessor: (payment) => payment.membership.id
            },
            {
                name: 'Nombre',
                id: 'membership.person.name',
                filterable: true,
                accessor: payment => payment.membership.person.name
            },
            {
                name: "Apellido Paterno:",
                id: "membership.person.patLastName",
                filterable: true,
                accessor: payment => payment.membership.person.patLastName
            },
            {
                name: "Apellido Materno:",
                id: "membership.person.matLastName",
                filterable: true,
                accessor: payment => payment.membership.person.matLastName
            },
            {
                name: 'Fecha de pago',
                id: 'paymentDate',
                accessor: (payment) => moment(payment.paymentDate).format('DD/MM/YYYY')
            },
            {
                name: 'Anualidad',
                id: 'year',
                filterable: true,
                accessor: 'year'
            }
        ];

        if (window.security.core.canManagePayments()) {
            tableDefinition.unshift({
                name: 'Acciones', accessor: (data, index) =>
                    <span>
                        <button className='btn btn-xs btn-primary' data-index={index} onClick={this.onEditPayment}><i
                            className='ti-pencil'/></button>
                        &nbsp;
                        <button className='btn btn-xs btn-danger' data-index={index} onClick={this.onDeletePayment}><i
                            className='ti-trash'/></button>
                    </span>
            });
        }
        return tableDefinition;
    }

    render() {
        return (
            <div className="container-fluid People">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Pagos</h4>
                            </div>
                            <div className="card-content">

                                <div className='buttonContainer'>
                                    {window.security.core.canManagePayments() &&
                                        <button className='btn btn-success btn-fill btn-magnify pull-right'
                                                onClick={this.openAddPayment}>
                                            <span className='btn-label'><i className='ti-plus'/></span>
                                        </button>}
                                    <a href={this.context.api.annuityPayments.exportUrl(this.tableState ? {
                                        ...this.tableState.filters,
                                        type: 'membership',
                                        'order[membership.id]': 'ASC',
                                        'order[paymentDate]': 'DESC'
                                    } : null, 'xlsx', 'Pagos de anualidades AMCEMIG')}>
                                        <button
                                            className='btn btn-info btn-fill btn-magnify pull-right download-report'>
                                            <span className='btn-label'>Descargar excel</span>
                                        </button>
                                    </a>
                                    <a href={this.context.api.annuityPayments.exportUrl(this.tableState ? {
                                        ...this.tableState.filters,
                                        type: 'membership',
                                        'order[membership.id]': 'ASC',
                                        'order[paymentDate]': 'DESC'
                                    } : null, 'pdf', 'Pagos de anualidades AMCEMIG')}>
                                        <button
                                            className='btn btn-info btn-fill btn-magnify pull-right download-report'>
                                            <span className='btn-label'>Descargar PDF</span>
                                        </button>
                                    </a>
                                    <div className='clearfix'/>
                                </div>

                                <Table
                                    paginated
                                    defaultPageSize={50}
                                    rowIdAccessor={'id'}
                                    totalItems={this.props.annuityPaymentsMeta.totalItems}
                                    loadData={this.loadData}
                                    columns={this.tableDefinition()}
                                    data={this.props.annuityPayments}
                                    trProps={this.getTrProps}

                                />


                            </div>
                        </div>
                    </div>

                </div>

                {/*  New payment Modal */}
                {this.state.addingPayment ?
                    <AnnuityPaymentFormModal
                        type={"membership"}
                        onHide={this.closeAddPayment}
                    />
                    : null}

                {/*  Edit payment Modal */}
                {this.state.editingPayment ?
                    <AnnuityPaymentFormModal
                        type={"membership"}
                        onHide={this.closeEditPayment}
                        editing={this.props.annuityPayments[this.state.editingPayment]}
                    />
                    : null}

                {/* Delete payment Modal*/}
                {this.state.deletingPayment ?
                    <DeleteAnnuityPaymentModal
                        type={"membership"}
                        annuityPayment={this.props.annuityPayments[this.state.deletingPayment]}
                        onHide={this.closeDeletePayment}
                        onConfirm={this.deletePayment}
                    />
                    : null}

                {/* Show payment detail Modal*/}
                {this.state.detailingPayment ?
                    <AnnuityPaymentDetailModal
                        type={"membership"}
                        annuityPayment={this.props.annuityPayments[this.state.detailingPayment]}
                        urlCreator={this.context.api.appFiles.getUrl}
                        onHide={this.closeDetailPayment}
                    />
                    : null}

            </div>
        );
    }
}

const mapStateToProps = ({api: {annuityPayments = [], annuityPaymentsMeta = {}}}) => {
    return {annuityPayments, annuityPaymentsMeta}
};

export default connect(mapStateToProps)(MembershipAnnuityPayments);


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/AnnuityPayments/MembershipAnnuityPayments/index.jsx